import { render, staticRenderFns } from "./projectMember.vue?vue&type=template&id=41c214f0&scoped=true&"
import script from "./projectMember.vue?vue&type=script&lang=ts&"
export * from "./projectMember.vue?vue&type=script&lang=ts&"
import style0 from "./projectMember.vue?vue&type=style&index=0&id=41c214f0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c214f0",
  null
  
)

export default component.exports